import { Draft } from '@reduxjs/toolkit';

import { ICompanyData } from '../../initialState';

function createSuccess(draft: Draft<ICompanyData>) {
  draft.create.config.isLoading = false;
}

export default createSuccess;
